import React, { Component } from 'react'
import { bool } from 'prop-types'
import delve from 'dlv'
import { fetchSchema, fetchIntegration } from 'src/common/utility/schemaHelpers'

const SchemaContext = React.createContext()

export class SchemaProvider extends Component {
  static propTypes = {
    isAdmin: bool
  }

  static defaultProps = {
    isAdmin: false
  }

  state = {
    loading: true,
    error: null,
    schema: null
  }

  UNSAFE_componentWillMount () {
    const src = this.props.isAdmin ? 'module' : 'product'
    const {
      schema: schemaUrl,
      integration: integrationUrl,
      extensionsBaseUrl
    } = delve(window, `clientOptions.${src}.options`, {})

    fetchSchema({ schemaUrl, extensionsBaseUrl })
      .then(schema => fetchIntegration(integrationUrl).then(() => schema))
      .then(schema => {
        this.setState(prevState => ({ ...prevState, loading: false, schema }))
      })
      .catch(error => {
        this.setState(prevState => ({ ...prevState, loading: false, error }))
      })
  }

  render () {
    return (
      <SchemaContext.Provider value={this.state}>
        {this.props.children}
      </SchemaContext.Provider>
    )
  }
}

export class SchemaConsumer extends Component {
  render () {
    return (
      <SchemaContext.Consumer>{this.props.children}</SchemaContext.Consumer>
    )
  }
}
